module.exports = __webpack_public_path__ + "assets/img/store-4.c5cb49d9.png";